import { ApprovalTimeEntry } from '../types/time-tracking-approvals';
import { isLoadMoreRow } from './approval-load-more-row.helper';

export const isEmptyDescription = (entry: Pick<ApprovalTimeEntry, 'description'>): boolean =>
  !entry.description || entry.description.trim().length === 0;

export const countEmptyDescriptions = (entries: ApprovalTimeEntry[]): number =>
  entries.reduce(
    (count, entry) => (!isLoadMoreRow(entry) && isEmptyDescription(entry) ? count + 1 : count),
    0
  );
